<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="上传"
    width="520px"
    :close-on-click-modal="false"
    @closed="resetForm"
  >
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="90px" size="mini">
      <el-form-item label="店铺" prop="storeId">
        <el-select
          v-model="formData.storeId"
          placeholder="请选择店铺"
          style="width: 100%"
          @change="handleStoreChange"
        >
          <el-option
            v-for="item in storeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="选择模板" prop="templateId">
        <template-select
          v-model="formData.templateId"
          :store-id="formData.storeId"
          @change="handleTemplateChange"
        />
      </el-form-item> -->
      <el-form-item label="上传文件" prop="file">
        <el-upload
          action=""
          :auto-upload="false"
          :show-file-list="true"
          :file-list="fileList"
          :limit="1"
          accept=".xls,.xlsx"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
        >
          <el-button size="mini" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">仅支持 xls、xlsx 文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="上传贴图">
        <el-upload
          action=""
          :auto-upload="false"
          :show-file-list="true"
          :file-list="stickerFileList"
          :limit="1"
          accept=".jpg,.jpeg,.png"
          :on-change="handleStickerChange"
          :on-remove="handleStickerRemove"
        >
          <el-button size="mini" type="primary">选择贴图</el-button>
          <div slot="tip" class="el-upload__tip">仅支持 jpg、png 文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="模板">
        <el-link type="primary" @click="downLoadTemplate">下载模板</el-link>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mockService from '../../mockService'

export default {
  name: 'ActivityUploadDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    folderId: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      storeOptions: [],
      templateData: null,
      fileList: [],
      stickerFileList: [],
      formData: {
        storeId: '',
        // templateId: '',
        templateName: '',
        stickerFile: null,
        stickerUrl: ''
      },
      rules: {
        storeId: [
          { required: true, message: '请选择店铺', trigger: 'change' }
        ]
        // templateId: [
        //   { required: true, message: '请选择模板', trigger: 'change' }
        // ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  mounted () {
    this.initOptions()
    this.getTemplate()
  },
  methods: {
    initOptions () {
      mockService.getStoreOptions().then(res => {
        this.storeOptions = res.data || []
      })
    },
    getTemplate () {
      this.$q.common.getTemplate({ fragment: 'storeDecorationImport' }).then((res) => {
        this.templateData = res.data
      })
    },
    downLoadTemplate () {
      if (!this.templateData || !this.templateData.templatePath) {
        this.$message.error('模板获取失败')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        this.downLoad(this.templateData.templatePath, `${this.templateData.fileName}.XLSX`)
        loading.close()
      }, 300)
    },
    downLoad (path, name) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', path, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, name)
          } else {
            const link = document.createElement('a')
            const body = document.querySelector('body')
            link.href = window.URL.createObjectURL(xhr.response)
            link.download = name
            link.style.display = 'none'
            body.appendChild(link)
            link.click()
            body.removeChild(link)
            window.URL.revokeObjectURL(link.href)
          }
        }
      }
      xhr.send()
    },
    handleStoreChange () {
      // this.formData.templateId = ''
      this.formData.templateName = ''
    },
    handleTemplateChange ({ option }) {
      this.formData.templateName = option.templateName || ''
    },
    handleFileChange (file, fileList) {
      const name = (file.raw && file.raw.name) || file.name || ''
      const ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (['xls', 'xlsx'].indexOf(ext) === -1) {
        this.$message.error('仅支持 xls、xlsx 文件')
        this.fileList = []
        return
      }
      this.fileList = fileList.slice(-1)
    },
    handleFileRemove (file, fileList) {
      this.fileList = fileList
    },
    handleStickerChange (file, fileList) {
      const name = (file.raw && file.raw.name) || file.name || ''
      const ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (['jpg', 'jpeg', 'png'].indexOf(ext) === -1) {
        this.$message.error('仅支持 jpg、png 文件')
        this.handleStickerRemove(file, [])
        return
      }
      this.stickerFileList = fileList.slice(-1)
      this.formData.stickerFile = file.raw || file
      this.formData.stickerUrl = ''
    },
    handleStickerRemove (file, fileList) {
      this.stickerFileList = fileList
      this.formData.stickerFile = null
      this.formData.stickerUrl = ''
    },
    uploadSticker () {
      const file = this.stickerFileList[0] && (this.stickerFileList[0].raw || this.stickerFileList[0])
      if (!file) return Promise.resolve('')

      const formData = new FormData()
      formData.append('files', file)
      formData.append('uploadDTOs', JSON.stringify([{ isCompress: 0, fileName: file.name, fileType: '1' }]))
      return this.$q.newProduct.storeDecorationStickerUpload({
        data: formData
      }).then(res => {
        if (!res || !res.data || !res.data.length) {
          throw new Error((res && res.message) || '贴图上传失败')
        }
        this.formData.stickerUrl = res.data[0].filePath
        return res.data[0].filePath
      })
    },
    handleConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (!this.fileList.length) {
          this.$message.error('请先选择上传文件')
          return
        }
        this.uploadSticker().then(stickerUrl => {
          const store = this.storeOptions.find(item => item.value === this.formData.storeId) || {}
          this.$emit('confirm', {
            // tempId: this.formData.templateId,
            storeId: this.formData.storeId,
            storeName: store.label || '',
            // templateId: this.formData.templateId,
            templateName: this.formData.templateName,
            stickerUrl,
            file: this.fileList[0]
          })
        }).catch(error => {
          this.$message.error((error && error.message) || '贴图上传失败')
        })
      })
    },
    resetForm () {
      this.formData = {
        storeId: '',
        // templateId: '',
        templateName: '',
        stickerFile: null,
        stickerUrl: ''
      }
      this.fileList = []
      this.stickerFileList = []
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate()
      }
    }
  }
}
</script>
